import { useTranslation } from 'react-i18next';
import { Badge } from '@/components';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/Tooltip';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { WebhookDelivery } from '@/types/alert';
import { formatDate } from '@/utils/date';

interface WebhookDeliveryTimeCellProps {
    delivery: WebhookDelivery;
    isFirstToUrl: boolean;
}

export function WebhookDeliveryTimeCell({
    delivery,
    isFirstToUrl,
}: WebhookDeliveryTimeCellProps) {
    const { t } = useTranslation(I18nNamespace.ALERT_RULES);

    return (
        <div className="flex items-center gap-2">
            <span>{formatDate(delivery.createdAt)}</span>
            {isFirstToUrl && (
                <Tooltip delayDuration={0}>
                    <TooltipTrigger asChild>
                        <span className="shrink-0">
                            <Badge
                                variant="warning"
                                value={t('webhookDeliveries.urlChanged')}
                            />
                        </span>
                    </TooltipTrigger>
                    <TooltipContent side="top" className="break-all">
                        {t('webhookDeliveries.urlChangedTooltip', {
                            url: delivery.url,
                        })}
                    </TooltipContent>
                </Tooltip>
            )}
        </div>
    );
}
